var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.64063H8.5V7.14063V6.14063C8.5 5.86449 8.72386 5.64063 9 5.64063H11C11.2761 5.64063 11.5 5.86449 11.5 6.14063V7.14063V7.64063H12H14H14.5V7.14063V6.14063C14.5 5.86449 14.7239 5.64063 15 5.64063H17C17.2761 5.64063 17.5 5.86449 17.5 6.14063V7.14063V7.64063H18H19C19.2761 7.64063 19.5 7.86449 19.5 8.14063V14.1406C19.5 14.4168 19.2761 14.6406 19 14.6406H7C6.72386 14.6406 6.5 14.4168 6.5 14.1406V8.14063C6.5 7.86449 6.72386 7.64063 7 7.64063H8ZM7.5 13.1406V13.6406H8H18H18.5V13.1406V9.14063V8.64063H18H8H7.5V9.14063V13.1406ZM18.5 18.1406V17.6406H18H8H7.5V18.1406V19.1406V19.6406H8H18H18.5V19.1406V18.1406ZM0.5 3.14063C0.5 1.75991 1.61929 0.640625 3 0.640625H23C24.3807 0.640625 25.5 1.75991 25.5 3.14062V23.1406C25.5 24.5213 24.3807 25.6406 23 25.6406H3C1.61929 25.6406 0.5 24.5213 0.5 23.1406V3.14063ZM4.00002 1.64063C2.61931 1.64063 1.50002 2.75992 1.50002 4.14063V22.1406C1.50002 23.5213 2.61931 24.6406 4.00002 24.6406H22C23.3807 24.6406 24.5 23.5213 24.5 22.1406V4.14063C24.5 2.75992 23.3807 1.64063 22 1.64063H4.00002ZM6.5 20.6406V16.6406H19.5V20.6406H6.5Z",
    fill: "#757575",
    stroke: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickIcon);
export default __webpack_public_path__ + "static/media/brickIcon.ca146fd67aa063a37749b590bf1b159d.svg";
export { ForwardRef as ReactComponent };